
export const fileHelper = {

    sizeInKB(sizeInBytes: number): string
    {
        const sizeKb = sizeInBytes / 1024;
        let fractionDigits = 3;
        
        if(sizeKb >= 1)
            fractionDigits = 2;
        if(sizeKb >= 10)
            fractionDigits = 1;
        if(sizeKb >= 100)
            fractionDigits = 0;

        const sizeString = sizeKb.toLocaleString(
            undefined,
            {
                minimumIntegerDigits:1,
                maximumFractionDigits:fractionDigits,
                minimumFractionDigits:fractionDigits,
            });
        return sizeString;
    }
}